import ENV from "config/Env";
import { backendQueryKey, localQueryKey } from "hooks/useTypedQuery";

import type { Device } from "models";
import type { PAGE_SIZE } from "utils/common";
import type { PaginatedItems } from "utils/paginatedItems";

const component = "DevicesDashboard";

export enum SORT_BY {
  LastUsedAscending = 1,
  LastUsedDescending,
  FreeSpaceAscending,
  FreeSpaceDescending
}

export type DevicePayload = {
  dealer_ids: number[];
  dealer_location_ids: number[];
  brands: string[];
  models: string[];
  os_versions: string[];
  search_term: string;
  order_by: SORT_BY | null;
  page: number;
  page_size: PAGE_SIZE;
};

export const DevicesDashboardQueryKeys = {
  filters: localQueryKey<DevicePayload>({ component, data: "filters" }),
  models: backendQueryKey<string[]>({ component, baseUrl: ENV.systemBaseURL, endpoint: "/devices/models/list" }),
  brands: backendQueryKey<string[]>({ component, baseUrl: ENV.systemBaseURL, endpoint: "/devices/brands/list" }),
  devices: backendQueryKey<PaginatedItems<Device>>({ component, baseUrl: ENV.systemBaseURL, endpoint: "/devices/list" }),
  osVersions: backendQueryKey<string[]>({ component, baseUrl: ENV.systemBaseURL, endpoint: "/devices/os_versions/list" })
};
